import React, {useContext} from 'react';
import { signinContext } from '../AdminSignin';

const InputSignin = (props) => {

  const {setSigninForm, siginForm} = useContext(signinContext)

  const handleChange = (e) => {
    let newForm = siginForm;
    newForm[e.target.name] = e.target.value;
    setSigninForm(newForm)
  }

  return (
    <div className={`InputSignin ${props.className}`}>
      <label htmlFor = {`signin-${props.name}`}>{props.label}</label>
      <input 
        id = {`signin-${props.name}`}
        name = {props.name}
        type={props.type}
        placeholder = {props.placeholder}
        value = {props.value}
        onChange = {handleChange}
      />
    </div>
  );
}

export default InputSignin;